import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, DefaultValues, FieldValues } from "react-hook-form";
import { ObjectSchema } from "yup";

export const useValidation = <T extends FieldValues>(
  validationSchema: ObjectSchema<T>,
  defaultValues: DefaultValues<T>
) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm<T>({
    defaultValues,
    resolver: yupResolver(validationSchema) as any,
  });

  return { register, handleSubmit, errors, reset };
};
